import React from 'react';
import ArrowLeft from '../../../../Assets/icons/ArrowLeft';
import FuelIcon from '../../../../Assets/icons/FuelIcon';
import { useNavigate } from 'react-router-dom';
import { Pathname } from '../../../../Router/Pathname';
import HeartToggle from '../../../../Components/Common/HeartToggle/HeartToggle';

const ConnectorHeader = ({ stationName, isFavourite, onToggleFavourite, backTo }) => {
    const navigate = useNavigate();
    return (
        <>
            {' '}
            <section className="SearchConnector__Header">
                <div
                    className="SearchConnector__Left"
                    onClick={() => navigate(backTo || Pathname.SEARCH_STATIONS)}
                >
                    <ArrowLeft />
                </div>
                <div className="SearchConnector__Right">
                    <div className="SearchConnector__Title">Search Connector</div>
                    <div className="SearchConnector__Address">
                        <FuelIcon />
                        <span className="SearchConnector__SubTitle">{stationName}</span>
                    </div>
                </div>
                <HeartToggle
                    isFavourite={isFavourite}
                    stationName={stationName}
                    onToggle={onToggleFavourite}
                    size={24}
                    style={{ marginLeft: 'auto', alignSelf: 'center' }}
                />
            </section>
        </>
    );
};

export default ConnectorHeader;
